import {
  ApiResponse,
  CancelImageGenerationPostRequest,
  ImageGenerationApi,
  ImageGenerationGetImagesByIdsRequest,
  ImageGenerationOnPostRequest,
  ImageGenerationStartResponse,
  InitOverrideFunction,
} from "../../../@api";

export class ImageGenerationApiService
  implements Omit<ImageGenerationApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: ImageGenerationApi) {}
  public async cancelImageGenerationPost(
    requestParameters?: CancelImageGenerationPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.cancelImageGenerationPost(requestParameters, initOverrides);
  }

  public async imageGenerationGetImagesByIds(requestParameters: ImageGenerationGetImagesByIdsRequest): Promise<Blob> {
    return this.api.imageGenerationGetImagesByIds(requestParameters);
  }

  public async imageGenerationGetImagesByIdsRaw(
    requestParameters: ImageGenerationGetImagesByIdsRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<Blob>> {
    return this.api.imageGenerationGetImagesByIdsRaw(requestParameters, initOverrides);
  }

  public async imageGenerationOnPost(
    requestParameters: ImageGenerationOnPostRequest,
  ): Promise<ImageGenerationStartResponse> {
    return this.api.imageGenerationOnPost(requestParameters);
  }
}
